<template>
  <v-dialog v-model="dialogShow" persistent width="520" height="285" class="dialog">
    <v-card>
      <v-card-title class="dialogTitle">
        <p class="dialogTitle-title">文件另存为</p>
        <v-spacer></v-spacer>
        <p @click="closeDialog" class="dialogTitle-close iconfontFamily">&#xe60d;</p>
      </v-card-title>
      <v-card-text style="padding:41px 48px 30px 39px;">
        <div style="display:flex;align-items:center;">
          <p style="font-size:16px;color:#000000;">文件名</p>
          <v-text-field v-model="folderName" dense outlined hide-details width="339" height="36" style="margin-left:46px;"></v-text-field>
        </div>
        <p :style="{'visibility':errorShow ? 'visible' : 'hidden'}" style="margin-left:93px;margin-top:5px;font-size:14px;color:#ff0000;"><span class="iconfontFamily">&#xe71f;</span>{{errorText}}</p>
        <div style="margin-top:49px;text-align:right;">
          <v-btn @click="resaveFolder" width="100" height="33" dark color="#1E3A8A">保存</v-btn>
        </div>
      </v-card-text>
    </v-card>

  </v-dialog>
</template>

<script>
export default {
  name: "ResaveSceneFolder",
  props:["dialogShow","oldSceneFolderName"],
  data(){
    return{

      folderName:"",

      errorShow:false,
      errorText:"",


    }

  },
  methods:{
    closeDialog(){
      this.$emit("closeDialog","")
    },


    //获取可用的另存为文件夹名称
    getResaveName(){
      this.$axios({
        method:"get",
        url:"/authorApi/z-screen-recorder/getAutoRecordName",
        params:{
          recordName:this.oldSceneFolderName
        }
      }).then((resultData)=>{
        resultData = resultData.data;
        console.log(resultData)
        if(resultData.status === 200){
          this.folderName = resultData.data
        }
        else{
          console.log(resultData.status + resultData.message);
        }
      }).catch((err)=>{
        console.log(err);
      });
    },


    //另存为文件夹
    async resaveFolder(){
      if(this.folderName.length > 30){
        this.errorText = "文件名超出30字"
        this.errorShow = true;
      }
      else if(this.folderName.trim().length === 0){
        this.errorText = "文件名不能为空"
        this.errorShow = true;
      }
      else{
        this.$parent.$parent.loadingDialogText = "另存中......"
        this.$parent.$parent.showLoadingDialog = true;

        //清除文件中的地球标记信息，再打开后重新加载
        let saveSceneList = JSON.parse(JSON.stringify(this.$store.state.sceneList))
        for(let i=0;i<saveSceneList.length;i++){
          saveSceneList[i].materialInfo.materialMarkerData = this.$store.state.defaultMaterialMarkerData;
          saveSceneList[i].materialInfo.materialMarkerUpdate = true;
          saveSceneList[i].scenePicture = await this.$utils.base64ToHttp(saveSceneList[i].scenePicture)
          for(let j=0;j<saveSceneList[i].viewPointList.length;j++){
            saveSceneList[i].viewPointList[j].viewPicture = await this.$utils.base64ToHttp(saveSceneList[i].viewPointList[j].viewPicture)
          }

        }

        this.$axios({
          method:"post",
          url:"/authorApi/z-screen-recorder/saveAs",
          data:{
            recordName:this.folderName,
            sceneList:saveSceneList
          }
        }).then((resultData)=>{
          resultData = resultData.data;
          console.log(resultData)
          if(resultData.status === 200){
            this.$parent.$parent.showLoadingDialog = false;
            setTimeout(()=>{
              this.$emit("resaveSceneFolderOk",resultData.data.recordId)
            },100)
          }
          else if(resultData.status === 309){
            this.errorText = "已存在同名文件"
            this.errorShow = true;

            this.$parent.$parent.showLoadingDialog = false;
          }
          else{
            console.log(resultData.status + resultData.message);
            this.$parent.$parent.showLoadingDialog = false;
          }
        }).catch((err)=>{
          console.log(err);
          this.$parent.$parent.showLoadingDialog = false;
        });
      }

    }



  },
  mounted(){
    this.getResaveName()
  }

}
</script>

<style scoped>

</style>
